import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../CustomedFields/FormikControl";
//** get actions from store */
import { useSelector, useDispatch } from "react-redux";
import {
  update_ProductItem_forEdit,
  update_MeasurementSettingDetails_forEdit,
} from "../../slice/orderSlice";

// function CustomerAdd(props, ref) {
const ProductAdd = React.forwardRef((props, ref) => {
  //Get state from store
  const { productItem, measurementSettingDetailForEdit } = useSelector(
    (state) => state.order
  );

  const initialValues = {
    Name: productItem ? "" : productItem?.name,
    Description: productItem ? "" : productItem?.description,
    Price: productItem ? "" : productItem?.price,
  };

  const validationSchema = Yup.object({
    Name: Yup.string().required("Required"),
    Description: Yup.string().required("Required"),
    Price: Yup.string().required("Required"), // .email("Invalid email format"),

    // bio: Yup.string().required("Required"),
    // course: Yup.string().required("Required"),
    // courseDate: Yup.date().required("Required").nullable(),
  });

  const onSubmit = async (values) => {
    console.log("Form data", JSON.stringify(values));
    alert("add customer submit:: " + JSON.stringify(values));
    props.AddProductItemToDB(values);
  };

  // const onSubmit = (event) => {
  //   alert("Form submitted");
  //   event.preventDefault();
  //   //Your code here. For example,
  // };

  //********************* Form validation send to Parent form */
  React.useEffect(() => {
    // Update the document title using the browser API
    // alert("document.getElementById(submitButton).disabled");
    props.isValidChildFormInputs(
      document.getElementById("submitButton")?.disabled
    );
  }, [document.getElementById("submitButton")?.disabled]);

  return (
    <>
      {productItem?.name}
      {productItem?.name}
      {productItem?.name}

      <Formik
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <Form>
              {/* <FormikControl
              control="input"
              type="text"
              label="MeasurementSettingsDetailsID_GUID"
              name="MeasurementSettingsDetailsID_GUID"
            /> */}
              {/* MeasurementSettingsID_GUID */}
              {/* IsNote */}
              {/* FieldType */}
              <FormikControl
                control="input"
                type="text"
                label="Name"
                name="Name"
              />
              <FormikControl
                control="input"
                type="text"
                label="Description"
                name="Description"
              />
              <FormikControl
                control="input"
                type="text"
                label="Price"
                name="Price"
              />

              <button
                id="submitButton"
                type="submit"
                disabled={
                  !formik.isValid || !formik.dirty || formik.isSubmitting
                }
                ref={ref}
              >
                Submit
              </button>
            </Form>
          );
        }}
      </Formik>
    </>
  );
});

export default ProductAdd;
